import useAuthUtilities from '@/AuthMiddleware/AuthUtilities';

export const usePermissionGuard = () => {
  const checkPermission = (): boolean => {
    return useAuthUtilities().canUserAccessEditUrl();
  };

  return {
    checkPermission,
  };
};
